import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { uuid } from '@atlaskit/adf-schema';
import { mapSlice } from '../utils/slice';
var transformSyncBlockNode = function transformSyncBlockNode(node, schema, isFromEditor) {
  // if copying from renderer, flatten out the content and remove the sync block
  if (!isFromEditor) {
    return node.content;
  }

  // sync blocks need a unique localId to function correctly
  var newAttrs = _objectSpread(_objectSpread({}, node.attrs), {}, {
    localId: uuid.generate()
  });
  return schema.nodes.syncBlock.create(newAttrs, null, _toConsumableArray(node.marks));
};
var transformBodiedSyncBlockNode = function transformBodiedSyncBlockNode(node, schema, isFromEditor) {
  // if copying from renderer, flatten out the content and remove the bodied sync block
  if (!isFromEditor) {
    return node.content;
  }

  // bodied sync blocks need a unique localId and convert to a reference sync block
  // when converting we want to be specific about attributes and marks we carry over
  var newAttrs = {
    resourceId: node.attrs.resourceId,
    localId: uuid.generate()
  };
  var newMarks = schema.nodes.syncBlock.markSet ? node.marks.filter(function (mark) {
    var _schema$nodes$syncBlo;
    return (_schema$nodes$syncBlo = schema.nodes.syncBlock.markSet) === null || _schema$nodes$syncBlo === void 0 ? void 0 : _schema$nodes$syncBlo.includes(mark.type);
  }) : node.marks; // schema.nodes.syncBlock.markSet is null meaning all marks are allowed

  return schema.nodes.syncBlock.create(newAttrs, null, newMarks);
};

/**
 * If we are copying from editor, transform the copied source or reference sync block to a new reference sync block
 * Otherwise, (e.g. if copying from renderer), flatten out the content and remove the sync block
 */
export var transformSyncBlock = function transformSyncBlock(slice, schema, pasteSource) {
  var isFromEditor = pasteSource === 'fabric-editor';
  slice = mapSlice(slice, function (node) {
    if (node.type === schema.nodes.syncBlock) {
      return transformSyncBlockNode(node, schema, isFromEditor);
    } else if (node.type === schema.nodes.bodiedSyncBlock) {
      return transformBodiedSyncBlockNode(node, schema, isFromEditor);
    }
    return node;
  });
  return slice;
};